import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        fontStyle: 'bold',
        marginBottom: "10px"
    },
    intervencion: {
        width: '25%',
        paddingLeft: 8,
        verticalAlign: "baseline",
    },
    text: {
        width: '75%',
        textAlign: 'left',
        paddingRight: 8,
        overflow: "break-word",
        opacity: 0.7
    },
});

const formated = (item) => {
    let text = ""
    switch (item.type) {
        case "text":
            text = item.text;
            break
        case "postback_button":
            const options = item.data
            for (let k = 0; k < options.length; k++) {
                text += "[" + options[k].text + "]  "
            }
            break
        case "rating":
            text = "(valoración en estrellas)"
            break;
        case "rated":
            text = item.rating + " estrellas"
            break
        case "warning":
            text = item.data[0].text
            break
        default:
            text = ""
    }

    return text
}

const Conversation = ({ items }) => {
    const rows = items.map((item, idx) =>
        <View style={styles.row} key={idx.toString()} wrap={false}>
            <Text style={styles.intervencion}>{item.isUser ? "Tú: " : "Asistente virtual: "}</Text>
            <Text style={styles.text}>{formated(item)}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment>)
};

export default Conversation